import { render, staticRenderFns } from "./batch_work_edit.vue?vue&type=template&id=aa6a3cd6&scoped=true"
import script from "./batch_work_edit.vue?vue&type=script&lang=js"
export * from "./batch_work_edit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa6a3cd6",
  null
  
)

export default component.exports